import React, { useEffect, useState } from "react";
import "./Register.css";
import "../Auth.css";
import {
  AiFillEye,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlinePhone,
  AiFillEyeInvisible,
} from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import { HiLockClosed } from "react-icons/hi";
import { IoCardOutline } from "react-icons/io5";
import { BasicInfo, toastFailed, toastSuccess } from "./../../Config/BasicInfo";
import { ApiPaths } from "./../../Config/ApiPath";
import { setLoginDisplay } from "../../Redux/LoginSlice";
import { setRegisterDisplay } from "../../Redux/RegisterSlice";
import useAxiosHelper from "./../../Common/AxiosHelper";
import Modal from "../../Components/Modal";
import PhoneInput, {
  formatPhoneNumber,
  formatPhoneNumberIntl,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import Select from "react-select";
import { ImCancelCircle } from "react-icons/im";
import { useDispatch } from "react-redux";
import TermsCondition from "../TermsConditions/TermsCondition";
import AuthLayout from "../../Components/AuthLayout";
const Register = () => {
  const { AxiosPost } = useAxiosHelper();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sponsorLoading, setSponsorLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [sponsorId, setSponsorId] = useState("");
  const [checkSponsorExist, setCheckSponsorExist] = useState(null);
  const [sponsorError, setSponsorError] = useState("");
  const [nameError, setNameError] = useState("");
  const [usenameError, setUsernameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [penCardError, setPenCardError] = useState("");
  const [confirmPasswordError, setconfirmPasswordError] = useState("");
  const [termCheck, setTermCheck] = useState(false);
  const [username, setUsername] = useState("");
  const [usernamefield, setUsernameField] = useState("");
  const [pancardfield, setPancardField] = useState("");
  const [sponsorUsername, setSponsorUsername] = useState("");
  const [pancard, setPancard] = useState("");
  const [firstId, setFirstId] = useState("");
  const [passwordVisility, setPasswordVisiblity] = useState(false);
  const [confirmPasswordVisility, setConfirmPasswordVisiblity] =
    useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [mobile, setMobile] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [registerData, setRegisterData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    penCard: "",
    // mobile: "",
  });
  const [showModal, setShowModal] = useState(false);
  // const navigate = useNavigate();

  // Email OTP (backend setting Registration.otp_before_register). The code is
  // tied to the email it was sent to, so changing the email invalidates it.
  const OTP_RESEND_SECONDS = 60;
  const [otpRequired, setOtpRequired] = useState(true);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSentTo, setOtpSentTo] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpCooldown, setOtpCooldown] = useState(0);

  const normalizedEmail = registerData.email.trim().toLowerCase();
  const otpSent = otpSentTo !== "" && otpSentTo === normalizedEmail;

  useEffect(() => {
    if (otpCooldown <= 0) return undefined;
    const t = setTimeout(() => setOtpCooldown((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [otpCooldown]);

  const sendOtp = async () => {
    setOtpError("");
    setEmailError("");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
      setEmailError("Enter a valid email to receive the code");
      return;
    }
    setOtpSending(true);
    try {
      const res = await AxiosPost(ApiPaths.sendRegistrationOTP, {
        email: normalizedEmail,
      });
      setOtpSentTo(normalizedEmail);
      setOtp("");
      setOtpCooldown(OTP_RESEND_SECONDS);
      toastSuccess(res?.message || "Verification code sent to your email");
    } catch (error) {
      const message = error?.response?.data?.message || "";
      if (/disabled/i.test(message)) {
        // Admin turned pre-registration OTP off — register without a code.
        setOtpRequired(false);
        return;
      }
      toastFailed(message || error?.message || "Could not send the code");
    } finally {
      setOtpSending(false);
    }
  };

  useEffect(() => {
    // Fetch country codes and names
    const countries = getCountries();
    const options = countries.map((code) => ({
      value: `+${getCountryCallingCode(code)}`,
      label: `${code} +${getCountryCallingCode(code)}`,
    }));
    setCountryOptions(options);
  }, [selectedCountry]);

  const handleCountryChange = (selectedOption) => {
    BasicInfo.isDebug && console.log("selectedOption", selectedOption);
    setSelectedCountry(selectedOption);
    // Optionally handle phone input update here
  };
  const openModal = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  const handleRegisterChange = (event) => {
    try {
      const { name, value } = event.target;
      setRegisterData({
        ...registerData,
        [name]: value,
      });
    } catch (e) {
      BasicInfo.isDebug && console.log(e);
    }
  };
  useEffect(() => {
    const ref = (
      new URLSearchParams(window.location.search).get("ref") || ""
    ).trim();
    if (ref.length > 0) {
      setSponsorId(ref);
      onUserStoppedTyping(ref);
    }
  }, []);
  const ChnageFun = () => {
    dispatch(setRegisterDisplay(false));
    dispatch(setLoginDisplay(true));
  };
  const LogRegister = async () => {
    const isFormValid = CheckValidation();
    const isOtpValid = CheckOtp();
    BasicInfo.isDebug && console.log(isFormValid);
    if (isFormValid == true && isOtpValid) {
      setLoading(true);
      try {
        const body = {
          sponsor: sponsorId,
          name: registerData.name.trim(),
          email: normalizedEmail,
          username: sponsorUsername,
          mobile: mobile,
          password: registerData.password,
          pancard: pancard,
          ...(otpRequired ? { otp, action: "register" } : {}),
        };
        const res = await AxiosPost(ApiPaths.register, body);
        if (res.status == 200) {
          const newUsername = res?.User?.username || sponsorUsername;
          toastSuccess(
            newUsername
              ? `Account created! Your username is ${newUsername}`
              : res?.message || "Registration successful."
          );
          dispatch(setRegisterDisplay(false));
          navigate("/login", { state: { username: newUsername } });
        }
      } catch (error) {
        const message = error?.response?.data?.message || "";
        if (/otp/i.test(message)) setOtpError(message);
        BasicInfo.isDebug && console.error(error);
        toastFailed(
          error?.response?.data?.message ||
            error?.message ||
            "Registration failed"
        );
      } finally {
        setLoading(false);
      }
    }
  };
  async function onUserStoppedTyping(sponID) {
    if (!sponID || sponID.trim().length === 0) {
      setCheckSponsorExist(null);
      return;
    }
    setSponsorLoading(true);
    try {
      const body = {
        username: sponID,
      };
      const res = await AxiosPost(ApiPaths.checkSponsor, body);

      if (res.status == 200) {
        setCheckSponsorExist(true);
        setUsername(res?.name);
      } else {
        setCheckSponsorExist(false);
        setUsername("");
      }
    } catch (error) {
      BasicInfo.isDebug && console.error("error here", error);
      setCheckSponsorExist(false);
      setUsername("");
    } finally {
      setSponsorLoading(false);
    }
  }

  // async function getFirstId() {
  //   setSponsorLoading(true);
  //   const res = await AxiosGet(ApiPaths.getFirstId);
  //   BasicInfo.isDebug && console.log("First Id ==>", res)
  //   setSponsorId(res?.userData?.username)
  // }

  // async function getFirstId() {
  //   try {
  //     setSponsorLoading(true);
  //     const res = await AxiosGet(ApiPaths.getFirstId);
  //     BasicInfo.isDebug && console.log("First Id ==>", res);
  //     setSponsorId(res?.userData?.username); // Set the sponsor ID from the response
  //     if (res?.userData?.username) {
  //       onUserStoppedTyping(res?.userData?.username); // Call the function to validate sponsor
  //     }
  //   } finally {
  //     setSponsorLoading(false);
  //   }
  // }

  const handleInputChange = (e) => {
    setSponsorError("");
    const value = e.target.value;
    setSponsorId(value);
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    if (value.trim().length > 0) {
      setTypingTimeout(
        setTimeout(() => {
          onUserStoppedTyping(value.trim());
        }, 500)
      );
    } else {
      setCheckSponsorExist(null);
    }
  };

  function resetError() {
    setSponsorError("");
    setNameError("");
    setUsernameError("");
    setEmailError("");
    setMobileError("");
    setPasswordError("");
    setconfirmPasswordError("");
    setPenCardError("");
  }
  function CheckOtp() {
    setOtpError("");
    if (!otpRequired) return true;
    if (!otpSent) {
      setOtpError("Verify your email — tap “Send code” first");
      return false;
    }
    if (!/^\d{6}$/.test(otp)) {
      setOtpError("Enter the 6-digit code sent to your email");
      return false;
    }
    return true;
  }

  function CheckValidation() {
    resetError();
    let x = 0;
    if (sponsorId.length === 0) {
      setSponsorError("Sponsor cannot be empty");
    } else if (checkSponsorExist === true) {
      x++;
    } else {
      setSponsorError("Sponsor does not exist");
    }
    if (registerData.name.trim().length === 0) {
      setNameError("Name cannot be empty");
    } else if (registerData.name.length >= 3) {
      const regex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
      if (regex.test(registerData.name.trim())) {
        x++;
      } else {
        setNameError("Invalid name");
      }
    } else {
      setNameError("Name should be atleast 3 characters");
    }

    if (sponsorUsername.trim().length === 0) {
      setUsernameError("Username cannot be empty");
    } else if (sponsorUsername.length >= 3) {
      const regex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
      if (regex.test(sponsorUsername)) {
        x++;
      } else {
        setUsernameError("Invalid username");
      }
    } else {
      setUsernameError("Username should be atleast 3 characters");
    }

    if (registerData.email.length === 0) {
      setEmailError("Email cannot be empty");
    } else {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (regex.test(registerData.email)) {
        x++;
      } else {
        setEmailError("Invalid email");
      }
    }

    if (!mobile || !isValidPhoneNumber(mobile)) {
      setMobileError("Invalid phone number");
    } else {
      x++;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

    if (registerData.password.length === 0) {
      setPasswordError("Password cannot be empty");
    } else if (!passwordRegex.test(registerData.password)) {
      setPasswordError(
        "Password should contain at least one lowercase letter, one uppercase letter, one digit,  and should be at least 8 characters long"
      );
    } else {
      x++;
    }
    if (registerData.confirmPassword.length === 0) {
      setconfirmPasswordError("Confirm password cannot be empty");
    } else {
      if (registerData.password === registerData.confirmPassword) {
        x++;
      } else {
        BasicInfo.isDebug && console.log("Password does not match");
        setconfirmPasswordError("Password does not match");
      }
    }

    if (pancardfield == "yes") {
      BasicInfo.isDebug && console.log("registerData.penCard", pancard);
      if (pancard.length === 0) {
        setPasswordError("Pancard field cannot be empty");
      } else {
        x++;
      }
    }

    BasicInfo.isDebug && console.log("x", x);
    let condition = 6;
    if (pancardfield == "yes") {
      condition = 7;
    }
    if (x === condition || x == 7 || x == 6) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      {loading ? <Loader /> : null}

      <AuthLayout
        title="Create your account"
        subtitle="Join in a few quick steps and start earning."
        footerText="Already have an account?"
        footerLinkText="Sign In"
        footerTo="/login"
        onFooterClick={ChnageFun}
      >
        <form className="authForm" onSubmit={(e) => e.preventDefault()}>
          <div className="authField">
            <label className="fieldLabel">Sponsor ID</label>
            <div className="fieldBox">
              <i className="fieldIcon">
                <AiOutlineUser />
              </i>
              <input
                type="text"
                id="sponsorId"
                name="sponsorId"
                placeholder="Enter sponsor ID"
                value={sponsorId}
                onChange={(e) => handleInputChange(e)}
              />
              {sponsorLoading ? <span className="fieldSpinner"></span> : null}
            </div>
          </div>
          {checkSponsorExist === true ? (
            <p className="authHint ok">Sponsor: {username}</p>
          ) : checkSponsorExist === false ? (
            <p className="authHint bad">Sponsor not exist</p>
          ) : null}
          {sponsorError ? <p className="authError">{sponsorError}</p> : null}

          {usernamefield == "manual" ? (
            <>
              <div className="authField">
                <label className="fieldLabel">Username</label>
                <div className="fieldBox">
                  <i className="fieldIcon">
                    <AiOutlineUser />
                  </i>
                  <input
                    type="text"
                    placeholder="Choose a username"
                    id="username"
                    name="username"
                    value={sponsorUsername}
                    onChange={(e) => setSponsorUsername(e.target.value)}
                  />
                </div>
              </div>
              {usenameError ? (
                <p className="authError">{usenameError}</p>
              ) : null}
            </>
          ) : (
            ""
          )}

          <div className="authField">
            <label className="fieldLabel">Full Name</label>
            <div className="fieldBox">
              <i className="fieldIcon">
                <AiOutlineUser />
              </i>
              <input
                type="text"
                placeholder="Enter your full name"
                id="name"
                name="name"
                value={registerData.name}
                onChange={(e) => handleRegisterChange(e)}
              />
            </div>
          </div>
          {nameError ? <p className="authError">{nameError}</p> : null}

          <div className="authField">
            <label className="fieldLabel">Email Address</label>
            <div className={`fieldBox ${otpRequired ? "hasAction" : ""}`}>
              <i className="fieldIcon">
                <AiOutlineMail />
              </i>
              <input
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder="you@example.com"
                id="email"
                name="email"
                value={registerData.email}
                onChange={(e) => handleRegisterChange(e)}
              />
              {otpRequired ? (
                <button
                  type="button"
                  className={`fieldAction ${otpSent ? "isSent" : ""}`}
                  onClick={sendOtp}
                  disabled={otpSending || (otpSent && otpCooldown > 0)}
                >
                  {otpSending ? (
                    <span className="fieldActionSpinner" />
                  ) : otpSent && otpCooldown > 0 ? (
                    `Resend ${otpCooldown}s`
                  ) : otpSent ? (
                    "Resend"
                  ) : (
                    "Send code"
                  )}
                </button>
              ) : null}
            </div>
          </div>
          {emailError ? <p className="authError">{emailError}</p> : null}

          {otpRequired && otpSent ? (
            <>
              <div className="authField">
                <label className="fieldLabel">Verification Code</label>
                <div className="fieldBox">
                  <i className="fieldIcon">
                    <RiLockPasswordFill />
                  </i>
                  <input
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    maxLength={6}
                    className="otpInput"
                    placeholder="••••••"
                    id="otp"
                    name="otp"
                    value={otp}
                    onChange={(e) => {
                      setOtpError("");
                      setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
                    }}
                  />
                </div>
              </div>
              <p className="authHint ok">
                Code sent to {otpSentTo} · valid for 10 minutes. Check spam if
                you don't see it.
              </p>
            </>
          ) : null}
          {otpError ? <p className="authError">{otpError}</p> : null}

          <div className="authField">
            <label className="fieldLabel">Mobile Number</label>
            <div className="authFieldPhone">
              <PhoneInput
                id="phoneInput"
                international
                countryCallingCodeEditable={false}
                defaultCountry="IN"
                value={mobile}
                onChange={setMobile}
              />
            </div>
          </div>
          {mobileError ? <p className="authError">{mobileError}</p> : null}

          {pancardfield == "yes" ? (
            <div className="authField">
              <label className="fieldLabel">Pan Card</label>
              <div className="fieldBox">
                <i className="fieldIcon">
                  <IoCardOutline />
                </i>
                <input
                  type="text"
                  placeholder="Enter pan card number"
                  id="pencard"
                  name="penCard"
                  value={pancard}
                  onChange={(e) => setPancard(e.target.value)}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="authField">
            <label className="fieldLabel">Password</label>
            <div className="fieldBox">
              <i className="fieldIcon">
                <HiLockClosed />
              </i>
              <input
                type={passwordVisility ? "text" : "password"}
                placeholder="Create a password"
                id="password"
                name="password"
                value={registerData.password}
                onChange={(e) => handleRegisterChange(e)}
              />
              <i
                className="fieldEye"
                onClick={() => setPasswordVisiblity(!passwordVisility)}
              >
                {passwordVisility ? <AiFillEye /> : <AiFillEyeInvisible />}
              </i>
            </div>
          </div>
          {passwordError ? <p className="authError">{passwordError}</p> : null}

          <div className="authField">
            <label className="fieldLabel">Confirm Password</label>
            <div className="fieldBox">
              <i className="fieldIcon">
                <HiLockClosed />
              </i>
              <input
                type={confirmPasswordVisility ? "text" : "password"}
                placeholder="Re-enter your password"
                id="confirmPassword"
                name="confirmPassword"
                value={registerData.confirmPassword}
                onChange={(e) => handleRegisterChange(e)}
              />
              <i
                className="fieldEye"
                onClick={() =>
                  setConfirmPasswordVisiblity(!confirmPasswordVisility)
                }
              >
                {confirmPasswordVisility ? (
                  <AiFillEye />
                ) : (
                  <AiFillEyeInvisible />
                )}
              </i>
            </div>
          </div>
          {confirmPasswordError ? (
            <p className="authError">{confirmPasswordError}</p>
          ) : null}

          <div className="authTerms">
            <input
              value={termCheck}
              type="checkbox"
              id="rememberme"
              onChange={(e) => setTermCheck(e.target.checked)}
            />
            <label htmlFor="rememberme">
              I agree to the{" "}
              <Link >
                Terms and Conditions
              </Link>
            </label>
            <Modal show={showModal} handleClose={closeModal}>
              <TermsCondition />
            </Modal>
          </div>

          <button
            disabled={!termCheck}
            className="authBtn"
            onClick={LogRegister}
            type="button"
          >
            Create Account
          </button>
        </form>
      </AuthLayout>
    </>
  );
};

export default Register;
